var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-capsule",
    {
      attrs: {
        formTitle: _vm.$t("businessDocuments.business_doc_negotiation"),
      },
    },
    [
      _c("template", { slot: "formcontent" }, [
        _vm._v("\n    " + _vm._s(_vm.document.id) + "\n  "),
      ]),
      _vm._v(" "),
      _c("template", { slot: "footerbuttons" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }